module.exports = __webpack_public_path__ + "static/overview-whats-1@2x-7e7c0bdf95fa3abbfc19493ca95219a2.png";